import { Box, Flex, VStack } from '@chakra-ui/react';
import { TwoColumnsLayout, useLayoutUtils } from '@supsupclub/ui-components';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { AnimatedBox } from '../../../common/components/animated-box';
import { Banners } from '../../../common/components/banners';
import { Router } from '../../../common/components/router';
import { Header } from '../../../user/components/header';
import { Menu } from '../../../user/components/menu';

export const Entry = () => {
  const { innerHeight, setGlobalHeight } = useLayoutUtils();
  const { pathname } = useLocation();

  useEffect(() => {
    const onResize = () => setGlobalHeight(window.innerHeight);
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, [setGlobalHeight]);

  useEffect(() => {
    const scroller = document.getElementById('scroller');
    if (scroller) {
      scroller.scrollTo({ top: 0 });
    }
  }, [pathname]);

  return (
    <TwoColumnsLayout>
      <VStack style={{ height: innerHeight }}>
        <Flex as="header" w="full" height={14} zIndex={10}>
          <Header />
        </Flex>
        <Box
          as="main"
          flex="1"
          w="full"
          p="0px 24px 92px"
          overflow="auto"
          id="scroller"
          css={{
            scrollBehavior: 'smooth',
            '&::-webkit-scrollbar': {
              width: 0,
              background: 'transparent',
            },
          }}
        >
          <Banners />
          <AnimatedBox key={pathname}>
            <Router />
          </AnimatedBox>
        </Box>
        <Flex
          as="footer"
          position="fixed"
          bottom="0"
          height={20}
          right="0"
          zIndex={5}
          left={{ base: '0', md: '50%' }}
        >
          <Menu />
        </Flex>
      </VStack>
    </TwoColumnsLayout>
  );
};
